import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { formatDate, formatDateTime, formattedDateLong } from "../Date";
import Modal from "react-bootstrap/Modal";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import usePermission from "../../config/permissions";
import ExpenseDetailsAdd from "../settings/model/Expense";
import { ExpenseAdd } from "../settings/model/ExpenseAddbutton";
import {
  customSortByKey,
  handleErrorToast,
  formatCurrencyIndian,
  handleAllError,
  formatRoundoff2D,
  ViewImprestRequestStatus,
  ViewImprestRequestDates,
} from "../CustomFunctions";
import {
  AddwithBlueCircle,
  AddwithWhiteCircle,
  CrosswithGreyCircle,
  CrosswithRedCircle,
  DropdownArrow,
  DropdownArrowOption,
  Eye,
} from "../AllSvg";
import CreatableSelect from "react-select/creatable";
import {
  AddProjectFromImprest,
  EmployeeImprestExpenseDashboard,
} from "../ImprestExpenseManagement/ImprestExpenseComponents";
import { CSSForSelect } from "../CustomUtilities";

const ImprestAdd = ({ getImprest }) => {
  const [show, setShow] = useState(false);
  const [allProjectList, setAllProjectList] = useState([]);
  const handleClose = () => {
    setFormData({
      date: "",
      empcode: sessionStorage.getItem("emp_code"),
      project_name: "",
      transportation: 0,
      accomodation: 0,
      fooding: 0,
      other_name: "",
      other: "",
      no_of_days: "",
      person: "",
      remarks: "",
      other_details: [],
    });
    setErrors({});
    setInputState({});
    setSelectedOptions([]);
    setShow(false);
  };

  const handleShow = () => {
    getAllempdata();
    getDepartments();
    getImprestTypeFormat();

    const empCode = sessionStorage.getItem("emp_code");
    const preSelectedOptions = allemployeedata
      .filter((employee) => employee.emp_code === empCode)
      .map((employee) => ({
        value: employee.emp_code,
        label: `${employee.emp_code} - ${employee.name}`,
      }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      empcode: empCode,
      multipleperson: preSelectedOptions.map((option) => option.value),
    }));

    setSelectedOptions(preSelectedOptions); // Set default selected options in the Select component

    setShow(true);
  };
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [toggleCompany, settToggleCompany] = useState(
    sessionStorage.getItem("company_id"),
  );

  const [formData, setFormData] = useState({
    date: "",
    empcode: sessionStorage.getItem("emp_code"),
    ref_project_code: "",
    ref_project_name: "",
    project_name: "",
    transportation: 0,
    accomodation: 0,
    fooding: 0,
    other_name: "",
    other: "",
    no_of_days: "",
    person: "",
    remarks: "",
    other_details: [
      // {
      //   other_name: "",
      //   amount: "",
      //   approved_other: 0,
      //   remaining_other: 0
      // },
    ],
  });

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const fieldLabels = {
    project_name: "Imprest Name",
    imprest_type: "Imprest Type",
    no_of_days: "Number of Days",
    department: "Department",
    ref_project_code: "Reference Project Code",
    ref_project_name: "Reference Project Name",
    date: "Date",
    person: "Person",
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "date",
      "project_name",
      "no_of_days",
      "imprest_type",
      formData.imprest_type === "project-related" ? "ref_project_code" : null,
      formData.imprest_type === "project-related" ? "ref_project_name" : null,
      selectedOptions.length > 0 ? null : "person",
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        const label = fieldLabels[field] || field; // fallback if not mapped
        newErrors[field] = `${label} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState((prev) => ({ ...prev, [name]: value.trim() ? "green" : "" }));
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setInputState({
  //     ...inputState,
  //     [name]: value.trim() ? "green" : "",
  //   });
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  //--------------------not used
  // const handlePrebidProjectInputChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "project_id") {
  //     const selectedProject = projectList.find((project) => project.pr_code === value);

  //     if (selectedProject) {
  //       const fullProjectName = `${selectedProject.prebid_prcode}-${selectedProject.project_short_name}`;
  //       let projectName = fullProjectName;
  //       if (fullProjectName.length > 200) {
  //         const maxShortNameLength = 200 - selectedProject.prebid_prcode.length - 4;
  //         const truncatedShortName = selectedProject.project_short_name.slice(0, Math.max(maxShortNameLength, 0));
  //         projectName = `${selectedProject.prebid_prcode}-${truncatedShortName}...`;
  //       }

  //       setFormData({
  //         ...formData,
  //         project_id: value,
  //         project_name: projectName,
  //         ref_project_code: selectedProject.prebid_prcode,
  //         ref_project_name: selectedProject.project_short_name,
  //       });

  //       setInputState({
  //         ...inputState,
  //         project_id: "green",
  //         project_name: "green",
  //         ref_project_code: "green",
  //         ref_project_name: "green",
  //       });
  //     } else {
  //       setFormData({
  //         ...formData,
  //         project_id: value,
  //         project_name: "",
  //         ref_project_code: "",
  //         ref_project_name: "",
  //       });

  //       setInputState({
  //         ...inputState,
  //         project_id: value.trim() ? "green" : "",
  //         project_name: "",
  //         ref_project_code: "",
  //         ref_project_name: "",
  //       });
  //     }
  //   } else {
  //     setInputState({
  //       ...inputState,
  //       [name]: value.trim() ? "green" : "",
  //     });

  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //     });
  //   }
  // };

  // const handleSiteProjectInputChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "project_id") {
  //     const selectedProject = projectList.find((project) => project.id === value);

  //     if (selectedProject) {
  //       const fullProjectName = `${selectedProject.site_prcode}-${selectedProject.project_short_name}`;
  //       let projectName = fullProjectName;
  //       if (fullProjectName.length > 200) {
  //         const maxShortNameLength = 200 - selectedProject.site_prcode.length - 4;
  //         const truncatedShortName = selectedProject.project_short_name.slice(0, Math.max(maxShortNameLength, 0));
  //         projectName = `${selectedProject.site_prcode}-${truncatedShortName}...`;
  //       }

  //       setFormData({
  //         ...formData,
  //         project_id: value,
  //         project_name: projectName,
  //         ref_project_code: selectedProject.site_prcode,
  //         ref_project_name: selectedProject.project_short_name,
  //       });

  //       setInputState({
  //         ...inputState,
  //         project_id: "green",
  //         project_name: "green",
  //         ref_project_code: "green",
  //         ref_project_name: "green",
  //       });
  //     } else {
  //       setFormData({
  //         ...formData,
  //         project_id: value,
  //         project_name: "",
  //         ref_project_code: "",
  //         ref_project_name: "",
  //       });

  //       setInputState({
  //         ...inputState,
  //         project_id: value.trim() ? "green" : "",
  //         project_name: "",
  //       });
  //     }
  //   } else {
  //     setInputState({
  //       ...inputState,
  //       [name]: value.trim() ? "green" : "",
  //     });

  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //     });
  //   }
  // };

  // const handleDepartmentProjectInputChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "project_id") {
  //     const selectedProject = projectList.find((project) => project.id === value);

  //     if (selectedProject) {
  //       const fullProjectName = `${selectedProject.project_code}-${selectedProject.project_name}`;
  //       let projectName = fullProjectName;
  //       if (fullProjectName.length > 200) {
  //         const maxShortNameLength = 200 - selectedProject.project_code.length - 4;
  //         const truncatedShortName = selectedProject.project_name.slice(0, Math.max(maxShortNameLength, 0));
  //         projectName = `${selectedProject.project_code}-${truncatedShortName}...`;
  //       }

  //       setFormData({
  //         ...formData,
  //         project_id: value,
  //         project_name: projectName,
  //         ref_project_code: selectedProject.project_code,
  //         ref_project_name: selectedProject.project_name,
  //       });

  //       setInputState({
  //         ...inputState,
  //         project_id: "green",
  //         project_name: "green",
  //         ref_project_code: "green",
  //         ref_project_name: "green",
  //       });
  //     } else {
  //       setFormData({
  //         ...formData,
  //         project_id: value,
  //         project_name: "",
  //         ref_project_code: "",
  //         ref_project_name: "",
  //       });

  //       setInputState({
  //         ...inputState,
  //         project_id: value.trim() ? "green" : "",
  //         project_name: "",
  //         ref_project_code: "",
  //         ref_project_name: "",
  //       });
  //     }
  //   } else {
  //     setInputState({
  //       ...inputState,
  //       [name]: value.trim() ? "green" : "",
  //     });

  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //     });
  //   }
  // };

  //-----------------not used

  const handleImprestTypeChange = async (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
      department: "",
      // project_id: "",
      mantra_project_id: "",
      project_name: "",
      ref_project_code: "",
      ref_project_name: "",
    });

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
      department: "",
      // project_id: "",
      mantra_project_id: "",
      project_name: "",
      ref_project_code: "",
      ref_project_name: "",
    });
    // setProjectList([]);
    setNewProject(false);

    // 🔄 Fetch all projects when imprest type is set to "project-related"
    if (value === "project-related") {
      await getFilterProjects(""); // Fetch without department filter
    } else {
      setProjectList([]); // Clear projects for non-project-related type
    }
  };

  const handleDepartmentChange = async (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
      // project_id: "",
      mantra_project_id: "",
      project_name: "",
      ref_project_code: "",
      ref_project_name: "",
    });

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
      // project_id: "",
      mantra_project_id: "",
      project_name: "",
      ref_project_code: "",
      ref_project_name: "",
    });

    setNewProject(false);

    // ✅ Filter client-side from already-fetched allProjectList
    if (value) {
      const filtered = allProjectList.filter(
        (p) => p.department === value || p.department === null,
      );
      setProjectList(filtered);
    } else {
      setProjectList(allProjectList); // no department → show all
    }
  };

  const handleOtherInputChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newOthers = [...prevFormData.other_details];
      newOthers[index] = {
        ...newOthers[index],
        [name]: value,
      };
      return {
        ...prevFormData,
        other_details: newOthers,
      };
    });
  };

  const handleAddOthers = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      other_details: [
        ...prevFormData.other_details,
        {
          other_name: "",
          amount: "0",
          approved_other: 0,
          remaining_other: 0,
        },
      ],
    }));
  };

  const handleRemoveOthers = (index) => {
    setFormData((prevFormData) => {
      const newOthers = [...prevFormData.other_details];
      newOthers.splice(index, 1);
      return {
        ...prevFormData,
        other_details: newOthers,
      };
    });
  };

  // ----------------------------------------------------------------
  // Project selection — ✅ CHANGE: no onCreate, employee can only
  // select from existing projects, not create new ones
  // ----------------------------------------------------------------
  // const handleProjectChange = (selectedOption) => {
  //   if (!selectedOption) {
  //     // User cleared the selection
  //     setFormData({
  //       ...formData,
  //       project_id: "",
  //       project_name: "",
  //       ref_project_code: "",
  //       ref_project_name: "",
  //     });
  //     return;
  //   }

  //   const selectedProject = projectList.find(
  //     (project) =>
  //       project.prebid_prcode === selectedOption.value ||
  //       project.site_prcode === selectedOption.value ||
  //       project.project_code === selectedOption.value
  //   );

  //   if (selectedProject) {
  //     const fullProjectName =
  //       formData.department === "Prebid"
  //         ? `${selectedProject.prebid_prcode}-${selectedProject.project_short_name}`
  //         : formData.department === "Site"
  //           ? `${selectedProject.site_prcode}-${selectedProject.project_short_name}`
  //           : `${selectedProject.project_code}-${selectedProject.project_short_name}`;

  //     setFormData({
  //       ...formData,
  //       project_id:
  //         formData.department === "Prebid"
  //           ? selectedProject.pr_code
  //           : selectedProject.id,
  //       project_name: fullProjectName,
  //       ref_project_code:
  //         formData.department === "Prebid"
  //           ? selectedProject.prebid_prcode
  //           : formData.department === "Site"
  //             ? selectedProject.site_prcode
  //             : selectedProject.project_code,
  //       ref_project_name:
  //         formData.department === "Prebid"
  //           ? selectedProject.project_short_name
  //           : formData.department === "Site"
  //             ? selectedProject.project_short_name
  //             : selectedProject.project_short_name,
  //     });

  //     setInputState({
  //       ...inputState,
  //       project_id: "green",
  //       project_name: "green",
  //       ref_project_code: "green",
  //       ref_project_name: "green",
  //     });
  //   }
  // };

  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        // project_id: "",
        mantra_project_id: "",
        project_name: "",
        ref_project_code: "",
        ref_project_name: "",
      });
      return;
    }

    // ✅ Match by project_code only
    const selectedProject = projectList.find(
      (project) => project.project_code === selectedOption.value,
    );

    if (selectedProject) {
      // ✅ Always use project_code and project_short_name
      const fullProjectName = `${selectedProject.project_code}-${selectedProject.project_short_name}`;

      setFormData({
        ...formData,
        // project_id: selectedProject.id,
        mantra_project_id: selectedProject.id,
        project_name: fullProjectName,
        ref_project_code: selectedProject.project_code, // ✅ payload key
        ref_project_name: selectedProject.project_short_name, // ✅ payload key
      });

      setInputState({
        ...inputState,
        // project_id: "green",
        mantra_project_id: "green",
        project_name: "green",
        ref_project_code: "green",
        ref_project_name: "green",
      });
    }
  };

  //******************Valedation End*********************** */

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,
      person: formData.multipleperson?.length,
    };

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/imprest/`, updatedFormData);

        if (res.status === 200) {
          await getImprest();
          handleClose();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleAllError(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  // useEffect(() => {
  //   getFilterProjects(formData.department);
  // }, [formData.department]);

  const [buffer1, setBuffering1] = useState(true);
  const [departmentLists, setDepartmentLists] = useState([]);
  const getDepartments = async () => {
    try {
      setBuffering1(true);
      const dep = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleCompany || "null"}/active/`,
      );
      setDepartmentLists(dep.data);
    } catch (err) {
    } finally {
      setBuffering1(false);
    }
  };

  const [allemployeedata, setAllemployee] = useState([]);

  const getAllempdata = async () => {
    try {
      const res = await axios.get(
        PERMISSION_AUTHORITY
          ? `${BASE_URL}/wfm/ourcompanyempdetailsactive/null/`
          : `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setAllemployee(sortedList);
      // setAllemployee(res.data);
    } catch (err) {
      alert(err.message);
    }
  };

  const [projectList, setProjectList] = useState([]);
  const [buffer, setBuffering] = useState(false); //buffering logic
  // const getFilterProjects = async (department) => {
  //   setBuffering(true); // Start Buffering
  //   try {
  //     let url = "";

  //     if (department === "Prebid") {
  //       url = `${BASE_URL}/project/projectfilterbysubcompany/null/`;
  //     } else if (department === "Site") {
  //       url = `${BASE_URL}/siteproject/project/`;
  //     } else if (department !== "") {
  //       url = `${BASE_URL}/mantra_projects/projects/?department_id=${department}&sub_company_id=${toggleCompany}`;
  //     }
  //     else {
  //       setProjectList([]);
  //       setBuffering(false);
  //       return;
  //     }
  //     const res = await axios.get(url);
  //     setProjectList(res.data || []);
  //   } catch (err) {
  //     handleErrorToast(err);
  //   } finally {
  //     setBuffering(false); // End Buffering
  //   }
  // };

  // const getFilterProjects = async (department) => {
  //   setBuffering(true);
  //   try {
  //     // Build URL dynamically - department_id is optional
  //     let url = `${BASE_URL}/mantra_projects/projects/?sub_company_id=${toggleCompany}`;
  //     if (department) {
  //       url += `&department_id=${department}`;
  //     }

  //     const res = await axios.get(url);
  //     setProjectList(res.data || []);
  //   } catch (err) {
  //     handleErrorToast(err);
  //   } finally {
  //     setBuffering(false);
  //   }
  // };

  const getFilterProjects = async (department) => {
    setBuffering(true);
    try {
      // Always fetch ALL projects for this sub_company (no department filter on API)
      // const url = `${BASE_URL}/mantra_projects/projects/?sub_company_id=${toggleCompany}`;
      const url = `${BASE_URL}/mantra_projects/projects/short-data/${toggleCompany}/`;
      const res = await axios.get(url);
      const data = res.data || [];
      // const data = res.data?.results || [];

      setAllProjectList(data); //  store full list

      //  Filter client-side if department is selected
      if (department) {
        const filtered = data.filter(
          (p) => p.department === department || p.department === null,
        );
        setProjectList(filtered);
      } else {
        setProjectList(data); // no filter → show all
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };
  const getImprestTypeFormat = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(
        `${BASE_URL}/wfm/imprest_type_format_subcompany/${toggleCompany}/`,
      );

      const formattedFormatData = res.data.map((item) => ({
        other_name: item.other_name || "",
        amount: item.amount || 0,
        approved_other: item.approved_other || 0,
      }));

      setFormData({
        ...formData,
        other_details: formattedFormatData,
      });
    } catch (error) {
      console.error(error);
      // handleErrorToast(error)
    } finally {
      setBuffering(false);
    }
  };

  const options = allemployeedata
    .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
    .map((e) => ({
      value: e.emp_code,
      label: `${e.emp_code} - ${e.name}`,
    }));

  const handleChangecc = (selected) => {
    const multipleperson =
      selected.length > 0 ? selected.map((item) => item.value) : "";
    setSelectedOptions(selected); // Update selected options state
    setFormData((prevState) => ({
      ...prevState,
      multipleperson,
    }));
  };

  // const handleProjectChange = (selectedOption) => {
  //   if (selectedOption) {
  //     const selectedProject = projectList.find(
  //       (project) =>
  //         project.prebid_prcode === selectedOption.value ||
  //         project.site_prcode === selectedOption.value ||
  //         project.project_code === selectedOption.value
  //     );

  //     if (selectedProject) {
  //       const fullProjectName =
  //         formData.department === "Prebid"
  //           ? `${selectedProject.prebid_prcode}-${selectedProject.project_short_name}`
  //           : formData.department === "Site"
  //             ? `${selectedProject.site_prcode}-${selectedProject.project_short_name}`
  //             : `${selectedProject.project_code}-${selectedProject.project_name}`;

  //       setFormData({
  //         ...formData,
  //         // project_id: selectedProject.id, // Assigning UUID from projectList
  //         project_id: formData.department === "Prebid"
  //           ? selectedProject.pr_code
  //           : selectedProject.id,
  //         project_name: fullProjectName,
  //         ref_project_code:
  //           formData.department === "Prebid"
  //             ? selectedProject.prebid_prcode
  //             : formData.department === "Site"
  //               ? selectedProject.site_prcode
  //               : selectedProject.project_code,
  //         ref_project_name:
  //           formData.department === "Prebid"
  //             ? selectedProject.project_short_name
  //             : formData.department === "Site"
  //               ? selectedProject.project_short_name
  //               : selectedProject.project_name,
  //       });

  //       setInputState({
  //         ...inputState,
  //         project_id: "green",
  //         project_name: "green",
  //         ref_project_code: "green",
  //         ref_project_name: "green",
  //       });
  //     }
  //   }
  // };

  const handleNoProjectChange = (inputValue) => {
    if (!inputValue) return;

    setFormData({
      ...formData,
      // project_id: '',
      mantra_project_id: "",
      project_name: inputValue,
      ref_project_code: inputValue,
      ref_project_name: inputValue,
    });

    setInputState({
      ...inputState,
      // project_id: "green",
      mantra_project_id: "green",
      project_name: "green",
      ref_project_code: "green",
      ref_project_name: "green",
    });
  };

  // ----------------------------------------------------------------
  // Project dropdown options — plain Select (not Creatable)
  // ----------------------------------------------------------------
  const projectOptions = projectList.map((data) => ({
    // value:
    //   formData.department === "Prebid"
    //     ? data.prebid_prcode
    //     : formData.department === "Site"
    //       ? data.site_prcode
    //       : data.project_code,
    // label:
    //   formData.department === "Prebid"
    //     ? `${data.prebid_prcode}`
    //     : formData.department === "Site"
    //       ? `${data.site_prcode}`
    //       : `${data.project_code}`,
    value: data.project_code,
    label: `${data.project_code} - ${data.project_short_name}`,
  }));

  const [newProject, setNewProject] = useState(false);

  return (
    <>
      <button title="Add Imperest" className="upload-svg" onClick={handleShow} style={{margin: '0'}}>
        <AddwithWhiteCircle /> Imprest
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Request Imprest</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Imprest Request</h6> */}
            <div className="form-flex-wrap">
              <div className="flex-column">
                <label
                  htmlFor="date"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Date<span className="required">*</span>
                </label>
                <input
                  id="date"
                  type="date"
                  name="date"
                  onChange={handleInputChange}
                  value={formData.date}
                  className={`form-input ${errors.date ? "error" : inputState.date ? "success" : ""
                    }`}
                />
                {errors.date && (
                  <span className="error-message font-size-text ">
                    {errors.date}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="imprest_type"
                  className="form-labels font-weight500 announce-date"
                >
                  Imprest Type<span className="required">*</span>
                </label>

                <select
                  name="imprest_type"
                  onChange={(e) => handleImprestTypeChange(e)}
                  value={formData.imprest_type}
                  className={`form-input`}
                >
                  <option value="">Select Type of Imprest</option>
                  <option value="non-project-related">
                    Not Related to a Project
                  </option>
                  <option value="project-related">Project Related</option>
                </select>
                {errors.imprest_type && (
                  <span className="error-message font-size-text ">
                    {errors.imprest_type}
                  </span>
                )}
              </div>

              {formData.imprest_type === "project-related" && (
                <div className="flex-column">
                  <label
                    htmlFor="department"
                    className="form-labels font-weight500 announce-date"
                  >
                    Department
                  </label>
                  {buffer1 ? (
                    <div className="form-loader">
                      <div className="bar-loader"></div>
                    </div>
                  ) : (
                    <>
                      <select
                        name="department"
                        onChange={(e) => handleDepartmentChange(e)}
                        value={formData.department}
                        className={`form-input  form-input-background`}
                      >
                        <option value="">Select Department for Projects</option>
                        {sessionStorage.getItem("company_id") ===
                          "025d0b52-e892-4868-a3bb-6b70dcdffb4d" ? (
                          <option value="Prebid">Prebid</option>
                        ) : null}
                        {departmentLists
                          .sort((a, b) => a.title.localeCompare(b.title))
                          .map((i, index) => (
                            <option key={i.id} value={i.id}>
                              {i.title}
                            </option>
                          ))}
                        ;
                      </select>
                    </>
                  )}
                  {errors.department && (
                    <span className="error-message font-size-text">
                      {errors.department}
                    </span>
                  )}
                </div>
              )}

              {/* {formData.imprest_type === 'project-related' && (
                <div className="flex-column">
                  <label
                    htmlFor="project_name"
                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  >
                    For {departmentLists.find(t => t.id === formData.department)?.title || ""}  Project Code<span className="required">*</span>
                  </label>

                  {buffer ? (
                    <div className="form-loader">
                      <div className="bar-loader"></div>
                    </div>
                  ) : (
                    <CreatableSelect
                      id="ref_project_code"
                      name="ref_project_code"
                      options={projectList.map(data => ({
                        value:
                          formData.department === 'Prebid'
                            ? data.prebid_prcode
                            : formData.department === 'Site'
                              ? data.site_prcode
                              : data.project_code,
                        label:
                          formData.department === 'Prebid'
                            ? data.prebid_prcode
                            : formData.department === 'Site'
                              ? data.site_prcode
                              : data.project_code,
                      }))}
                      onChange={(selectedOption) => {
                        setNewProject(false);
                        handleProjectChange(selectedOption);
                      }}
                      {...(formData.department !== 'Prebid' && formData.department !== 'Site'
                        ? {
                          onCreateOption: (inputValue) => {
                            setNewProject(true);
                            handleNoProjectChange(inputValue);
                          },
                        }
                        : {})}
                      value={
                        formData.ref_project_code
                          ? {
                            value: formData.ref_project_code,
                            label: formData.ref_project_code, // Ensure the label matches what should be displayed
                          }
                          : null
                      }
                      placeholder="Project Code"
                      className=""
                      styles={CSSForSelect}
                    />
                  )}
                  {errors.ref_project_code && (
                    <span className="error-message font-size-text">
                      {errors.ref_project_code}
                    </span>
                  )}
                </div>
              )} */}
              {/*  CHANGED: Project Code — plain Select, no create option */}
              {formData.imprest_type === "project-related" && (
                <div className="flex-column">
                  {/* <label
                    htmlFor="ref_project_code"
                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  >
                    For {departmentLists.find((t) => t.id === formData.department)?.title || ""}
                    {" "}Project<span className="required">*</span>
                  </label> */}
                  <label
                    htmlFor="ref_project_code"
                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  >
                    For{" "}
                    {departmentLists.find((t) => t.id === formData.department)
                      ?.title || ""}{" "}
                    Project<span className="required">*</span>
                  </label>

                  {buffer ? (
                    <div className="form-loader">
                      <div className="bar-loader"></div>
                    </div>
                  ) : (
                    <>
                      <Select
                        id="ref_project_code"
                        name="ref_project_code"
                        options={projectOptions}
                        onChange={handleProjectChange}
                        value={
                          formData.ref_project_code
                            ? {
                              value: formData.ref_project_code,
                              label:
                                projectOptions.find(
                                  (o) =>
                                    o.value === formData.ref_project_code,
                                )?.label || formData.ref_project_code,
                            }
                            : null
                        }
                        placeholder="Search & select project..."
                        isClearable
                        // ✅ REMOVED isDisabled — projects load as soon as type is selected
                        noOptionsMessage={() =>
                          projectList.length === 0
                            ? "No projects found. Contact Admin to add project."
                            : "No matching project"
                        }
                        styles={CSSForSelect}
                      />

                      {/* ✅ Helper text when no projects available */}
                      {projectList.length === 0 && !buffer && (
                        <span
                          className="form-hint font-size-text"
                          style={{ color: "#888", marginTop: "4px" }}
                        >
                          No projects found. Please contact Admin to add a
                          project.
                        </span>
                      )}
                    </>
                  )}

                  {errors.ref_project_code && (
                    <span
                      className="error-message font-size-text"
                      style={{ marginBottom: "0px", marginTop: "5px" }}
                    >
                      {errors.ref_project_code}
                    </span>
                  )}
                </div>
              )}

              {/* ─── Project Name (read-only, auto-fill) — unchanged logic ─────────── */}
              {formData.imprest_type === "project-related" && (
                <div className="flex-column">
                  <label
                    htmlFor="ref_project_name"
                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  >
                    Project Name<span className="required">*</span>
                  </label>
                  {buffer ? (
                    <div className="form-loader">
                      <div className="bar-loader"></div>
                    </div>
                  ) : (
                    <>
                      <input
                        id="ref_project_name"
                        type="text"
                        name="ref_project_name"
                        placeholder="Auto-filled on project selection"
                        value={formData.ref_project_name}
                        readOnly
                        style={{
                          cursor: "not-allowed",
                          backgroundColor: "#f5f5f5",
                        }}
                        className={`form-input ${errors.ref_project_name
                            ? "error"
                            : inputState.ref_project_name
                              ? "success"
                              : ""
                          }`}
                      />
                      {errors.ref_project_name && (
                        <span className="error-message font-size-text">
                          {errors.ref_project_name}
                        </span>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* {newProject === true ?
                <AddProjectFromImprest
                  i={formData}
                  departmentLists={departmentLists}
                  getFilterProjects={getFilterProjects}
                  setFormData={setFormData}
                  setInputState={setInputState}
                  setNewProject={setNewProject}
                />
                :
                null
              } */}

              <div className="flex-column">
                <label
                  htmlFor="project_name"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Imprest Name<span className="required">*</span>
                </label>
                {buffer ? (
                  <div className="form-loader">
                    <div className="bar-loader"></div>
                  </div>
                ) : (
                  <>
                    <input
                      id="project_name"
                      type="text"
                      name="project_name"
                      placeholder="Imprest Name"
                      onChange={handleInputChange}
                      value={formData.project_name}
                      className={`form-input ${errors.project_name
                          ? "error"
                          : inputState.project_name
                            ? "success"
                            : ""
                        }`}
                    />
                    {errors.project_name && (
                      <span className="error-message font-size-text ">
                        {errors.project_name}
                      </span>
                    )}
                  </>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="total"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Total Expense<span className="required">(Auto)</span>
                </label>
                <input
                  id="total"
                  type="number"
                  placeholder="5000"
                  value={
                    Number(formData.transportation) +
                    Number(formData.accomodation) +
                    Number(formData.fooding) +
                    formData.other_details?.reduce(
                      (total, other) => total + Number(other.amount || 0),
                      0,
                    )
                  }
                  readOnly
                  style={{ cursor: "not-allowed" }}
                  className="form-input   font-weight500   font-size-subheading"
                />
              </div>
              <hr className="line" />
              {formData.other_details.map((other, index) => (
                <>
                  <div className="flex-column">
                    <div className="flex-row">
                      <div className="flex-column">
                        <label
                          htmlFor={`other_name_${index}`}
                          className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                        >
                          Expense Name
                        </label>
                      </div>
                      {index !== 0 && (
                        <div className="">
                          <button
                            type="button"
                            title="Remove"
                            className="align-center flex-row action-div"
                            onClick={() => handleRemoveOthers(index)}
                          >
                            <CrosswithRedCircle />
                          </button>
                        </div>
                      )}
                    </div>
                    <input
                      id={`other_name_${index}`}
                      type="text"
                      name="other_name"
                      placeholder="Other Expense Name"
                      onChange={(e) => handleOtherInputChange(index, e)}
                      value={other.other_name}
                      className={`form-input`}
                    />
                  </div>

                  <div className="flex-column">
                    <label
                      htmlFor={`amount_${index}`}
                      className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                    >
                      {other.other_name
                        ? `${other.other_name} Expenses`
                        : "Other Expenses"}
                    </label>
                    <input
                      id={`amount_${index}`}
                      type="number"
                      name="amount"
                      placeholder="0"
                      min={0}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => handleOtherInputChange(index, e)}
                      value={other.amount}
                      className={`form-input`}
                    />
                  </div>
                </>
              ))}
            </div>

            <div className="flex-row">
              <hr className="line" />
              <button
                type="button"
                title="Add Document"
                className="flex-row jd-heading-main font-weight600 gap-2"
                onClick={handleAddOthers}
              >
                <AddwithBlueCircle />{" "}
                <span className="w-max-content">Expense Type</span>
              </button>
            </div>
            <div className="form-flex-wrap">
              <div className="flex-column">
                <label
                  htmlFor="no_of_days"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Number's of days<span className="required">*</span>
                </label>
                <input
                  id="no_of_days"
                  type="number"
                  placeholder="Days"
                  name="no_of_days"
                  min={0}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.no_of_days}
                  className={`form-input ${errors.no_of_days
                      ? "error"
                      : inputState.no_of_days
                        ? "success"
                        : ""
                    }`}
                />
                {errors.no_of_days && (
                  <span className="error-message font-size-text ">
                    {errors.no_of_days}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="person"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Name of Person<span className="required">*</span>
                </label>

                <Select
                  options={options}
                  isMulti
                  value={selectedOptions}
                  // value={options.filter((option) => formData.person.includes(option.value))}
                  onChange={handleChangecc}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      width: "33vw",
                      minHeight: "50px",
                      borderRadius: "10px",
                      border: "1px solid #e3e3e3",
                      margin: "10px 0px 20px 0px",
                      color: "#4a4a4a",
                      backgroundColor: "#f7f8fa",
                      padding: "0px 10px",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      borderRadius: "10px",
                      marginTop: "0",
                    }),
                    input: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                  }}
                />
                {errors.person && (
                  <span className="error-message font-size-text ">
                    {errors.person}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="person"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Number's of Person (Auto)
                </label>
                <input
                  id="person"
                  type="number"
                  name="person"
                  // onChange={handleInputChange}
                  readOnly
                  style={{ cursor: "not-allowed" }}
                  value={formData.multipleperson?.length}
                  className={`form-input ${errors.person ? "error" : inputState.person ? "success" : ""
                    }`}
                />
                {errors.person && (
                  <span className="error-message font-size-text ">
                    {errors.person}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="remarks"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Remarks
                </label>
                <textarea
                  id="remarks"
                  type="text"
                  name="remarks"
                  placeholder="Your feedback"
                  onChange={handleInputChange}
                  // maxLength={200}
                  value={formData.remarks}
                  className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks
                      ? "error"
                      : inputState.remarks
                        ? "success"
                        : ""
                    }`}
                />
                {errors.remarks && (
                  <span className="error-message font-size-text ">
                    {errors.remarks}
                  </span>
                )}
              </div>
            </div>
            {/* {newProject === true ?
              <span className="align-center required">
                Note : Unrecognized Project Code entered — Add Project first.
                <br />
                <AddProjectFromImprest
                  i={formData}
                  departmentLists={departmentLists}
                  getFilterProjects={getFilterProjects}
                  setFormData={setFormData}
                  setInputState={setInputState}
                  setNewProject={setNewProject}
                />
              </span> : */}

            <div className="button-models">
              <button
                className="model-button model-button-cancel   font-weight500   "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                onClick={handleFormSubmit}
                disabled={loading}
              >
                Add
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted &&
                Object.keys(errors).length > 0 &&
                (Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">
                    Please fill all mandatory fields!
                  </h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      .map(
                        (field) =>
                          fieldLabels[field] ||
                          field
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase()),
                      )
                      .join(", ") + " are required!"}
                  </h6>
                ))}
            </p>

            {/* // } */}
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const ImprestModelDelete = ({ id, getImprest }) => {
  const [show, setShow] = useState(false);

  console.log(id);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [loading, setLoading] = useState(false); //loading logic

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    setLoading(true); //loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/imprest/${id.id}/`);

      if (res.status === 200) {
        await getImprest();
        handleClose();
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleAllError(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
      setLoading(false); //loading logic
    }
  };

  return (
    <>
      <button
        title="Delete Imprest Request"
        className="model-delete-button"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Imprest</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Delete this Imprest Request
            <div className="button-models">
              <button
                className="model-button font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
                disabled={loading}
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const ExpenseSubmit = ({ i, getExpansee, total }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    getSpecificExpenses();
    setShow(true);
  };

  const [updatedlist, setExpenseDetails] = useState([]);
  const [sum, setSum] = useState("");
  const getSpecificExpenses = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/expensedetailsbyexpense/${i.id}/`,
      );

      const summ = res.data.reduce(
        (acc, item) => acc + parseFloat(item.item_amount),
        0,
      );
      setSum(summ);
      const uniqueDatesSet = new Set();
      res.data.forEach((item) => {
        uniqueDatesSet.add(item.date);
      });

      // console.log(uniqueDatesSet)
      setExpenseDetails(Array.from(uniqueDatesSet));
    } catch (err) { }
  };

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.put(`${BASE_URL}/wfm/expense/${i.id}/`, {
        utilized_amount: sum,
        remaining_amount: Number(total) - Number(sum),
        submit_for_approval: true,
        apply_datetime: new Date().toISOString(),
        partially_change: false,
        rh_status: "pending",
      });

      if (res.status === 200) {
        await getExpansee();
        // setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleAllError(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <button
        className="model-edit-button-ml"
        title="Submit Expense for Approval"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15 4.5L6.75 12.75L3 9"
            stroke="#145650"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>



      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body style={{ padding: 0 }}>
          <div className="ecm-shell">

            {/* ── Header ── */}
            <div className="ecm-header">

              <div>
                <p className="ecm-header-subtitle">Confirm expense submission</p>
                <p className="ecm-header-title">"{i.name}"</p>
              </div>
            </div>

            {/* ── Body ── */}
            <div className="ecm-body">

              {/* Date + Project chips */}
              <div className="ecm-info-grid">
                <div className="ecm-info-chip">
                  <p className="ecm-chip-label">Date</p>
                  <p className="ecm-chip-value">{formattedDateLong(i.date)}</p>
                </div>
                <div className="ecm-info-chip">
                  <p className="ecm-chip-label">Expense against imprest</p>
                  <p className="ecm-chip-value">{i.project_name}</p>
                </div>
              </div>

              {/* Amount split card */}
              <div className="ecm-amount-card">
                <div className="ecm-amount-split">

                  <div className="ecm-amount-cell">
                    <p className="ecm-amount-cell-label">Utilized amount</p>
                    <p className="ecm-amount-value ecm-amount-value--utilized">{sum}</p>
                  </div>

                  <div className="ecm-amount-cell">
                    <p className="ecm-amount-cell-label">Remaining amount</p>
                    <p className="ecm-amount-value ecm-amount-value--remaining">
                      {Number(total) - Number(sum)}
                    </p>
                  </div>

                </div>

                {/* Progress bar */}
                <div className="ecm-progress-track">
                  <div
                    className="ecm-progress-fill"
                    style={{
                      width: `${Math.min((Number(sum) / Number(total)) * 100, 100)}%`,
                    }}
                  />
                </div>
              </div>

              {/* Actions */}
              <div className="ecm-actions">
                <button className="ecm-btn-cancel" onClick={handleClose}>
                  Cancel
                </button>
                <button type="submit" className="ecm-btn-confirm" onClick={handleFormSubmitPut}>
                  <i className="ti ti-check" /> Confirm
                </button>
              </div>

            </div>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
      {/* chnges -------------------------------
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
                    chnges ------------------------------- */}
      {/* chnges -------------------------------
              <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                Confirm Expense Submission of "{i.name}"{" "}
              </h6>
              <div className="flex-row">
                <label
                  htmlFor="date"
                  className="form-labels font-weight500 announce-date font-weight400  font-size-heading"
                >
                  Date :
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {formattedDateLong(i.date)}
                </div>
              </div>

              <div className="flex-row">
                <label
                  htmlFor="project_name"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Expense against Imprest :
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {i.project_name}
                </div>
              </div>
      chnges ------------------------------- */}
      {/* <hr className="line" /> */}
      {/* chnges -------------------------------
              <hr className="line" />
              <div className="children">
                <div>
                  <label
                    htmlFor="fooding"
                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                  >
                    Utilized Amount
                  </label>
                  <p
                    className="utilize   font-weight500   -amount align-center"
                    style={{ color: "red" }}
                  >
                    {sum}
                  </p>
                </div>

                <div>
                  <label
                    htmlFor="fooding"
                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                  >
                    Remaining Amount
                  </label>
                  <p
                    className="remaining-amount  font-weight500    align-center"
                    style={{ color: "#2576bc" }}
                  >
                    {Number(total) - Number(sum)}
                  </p>
                </div>
              </div>
      chnges ------------------------------- */}
      {/* <br />
              <div className="flex-row">
                <label htmlFor="fooding" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Utilized Amount -
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {sum}
                </div>
              </div>
              <div className="flex-row">
                <label htmlFor="fooding" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Remaining Amount -
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {Number(total) - Number(sum)}
                </div>
              </div>
              <br /> */}

      {/* <div className="flex-row">
                <label htmlFor="total" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Imprest Amount :-
                </label>
              </div>

              <div className="flex-row">
                <label htmlFor="total" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Total -
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {
                    Number(i.transportation) +
                    Number(i.accomodation) +
                    Number(i.fooding) +
                    Number(i.other)
                  }
                </div>
              </div>

              <div className="flex-row">
                <label
                  htmlFor="transportation"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Transportation -
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {i.transportation}
                </div>

              </div>

              <div className="flex-row">
                <label
                  htmlFor="accomodation"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Accommodation -
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {i.accomodation}
                </div>

              </div>

              <div className="flex-row">
                <label htmlFor="fooding" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Food -
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {i.fooding}
                </div>
              </div>

              <div className="flex-row">
                <label htmlFor="other" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  {i.other_name ? `${i.other_name} Expenses - ` : 'Other Expenses - '}
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {i.other}
                </div>
              </div> */}
      {/* chnges -------------------------------
              <div className="button-models">
                <button
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button   font-weight500 model-button-leave font-weight500 font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Confirm
                </button>
              </div>
              chnges ------------------------------- */}
      {/* chnges ------------------------------- */}
      {/* </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

        </Modal.Body>
      </Modal > */}
      {/* chnges ------------------------------- */}
    </>
  );
};

const ExpensePartialSubmit = ({ i, getExpansee, total }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    getSpecificExpenses();
    setShow(true);
  };

  const [updatedlist, setExpenseDetails] = useState([]);
  const [sum, setSum] = useState("");
  const getSpecificExpenses = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/expensedetailsbyexpense/${i.id}/`,
      );

      const summ = res.data.reduce(
        (acc, item) => acc + parseFloat(item.bill_approved_amt),
        0,
      );
      setSum(summ);
      const uniqueDatesSet = new Set();
      res.data.forEach((item) => {
        uniqueDatesSet.add(item.date);
      });

      // console.log(uniqueDatesSet)
      setExpenseDetails(Array.from(uniqueDatesSet));
    } catch (err) { }
  };

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.put(`${BASE_URL}/wfm/expense/${i.id}/`, {
        utilized_amount: sum,
        remaining_amount: Number(total) - Number(sum),
        submit_for_approval: true,
        partially_change: false,
        // rh_status: "pending",
      });

      if (res.status === 200) {
        await getExpansee();
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleAllError(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <button
        className="model-edit-button-ml"
        title="Partial Submit Expense"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15 4.5L6.75 12.75L3 9"
            stroke="#145650"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {/* <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                Confirm Expense Submission of "{i.name}"{" "}
              </h6>
              <div className="flex-row">
                <label
                  htmlFor="date"
                  className="form-labels font-weight500 announce-date font-weight400  font-size-heading"
                >
                  Date :
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {formattedDateLong(i.date)}
                </div>
              </div>
              <div className="flex-row">
                <label
                  htmlFor="project_name"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Expense against Imprest :
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {i.project_name}
                </div>
              </div>
              <hr className="line" />
              <div className="children">
                <div>
                  <label
                    htmlFor="fooding"
                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                  >
                    Utilized Amount
                  </label>
                  <p
                    className="utilize   font-weight500   -amount align-center"
                    style={{ color: "red" }}
                  >
                    {sum}
                  </p>
                </div>
                <div>
                  <label
                    htmlFor="fooding"
                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                  >
                    Remaining Amount
                  </label>
                  <p
                    className="remaining-amount  font-weight500    align-center"
                    style={{ color: "#2576bc" }}
                  >
                    {Number(total) - Number(sum)}
                  </p>
                </div>
              </div>
              <div className="button-models">
                <button
                  className="model-button model-button-cancel  font-weight500   "
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal > */}

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body style={{ padding: 0 }}>
          <div className="ecm-shell">

            {/* ── Header ── */}
            <div className="ecm-header">

              <div>
                <p className="ecm-header-subtitle">Confirm expense submission</p>
                <p className="ecm-header-title">"{i.name}"</p>
              </div>
            </div>

            {/* ── Body ── */}
            <div className="ecm-body">

              {/* Date + Project chips */}
              <div className="ecm-info-grid">
                <div className="ecm-info-chip">
                  <p className="ecm-chip-label">Date</p>
                  <p className="ecm-chip-value">{formattedDateLong(i.date)}</p>
                </div>
                <div className="ecm-info-chip">
                  <p className="ecm-chip-label">Expense against imprest</p>
                  <p className="ecm-chip-value">{i.project_name}</p>
                </div>
              </div>

              {/* Amount split card */}
              <div className="ecm-amount-card">
                <div className="ecm-amount-split">

                  <div className="ecm-amount-cell">
                    <p className="ecm-amount-cell-label">Utilized amount</p>
                    <p className="ecm-amount-value ecm-amount-value--utilized">{sum}</p>
                  </div>

                  <div className="ecm-amount-cell">
                    <p className="ecm-amount-cell-label">Remaining amount</p>
                    <p className="ecm-amount-value ecm-amount-value--remaining">
                      {Number(total) - Number(sum)}
                    </p>
                  </div>

                </div>

                {/* Progress bar */}
                <div className="ecm-progress-track">
                  <div
                    className="ecm-progress-fill"
                    style={{
                      width: `${Math.min((Number(sum) / Number(total)) * 100, 100)}%`,
                    }}
                  />
                </div>
              </div>

              {/* Actions */}
              <div className="ecm-actions">
                <button className="ecm-btn-cancel" onClick={handleClose}>
                  Cancel
                </button>
                <button type="submit" className="ecm-btn-confirm" onClick={handleFormSubmitPut}>
                  <i className="ti ti-check" /> Confirm
                </button>
              </div>

            </div>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const ExpenseModelDelete = ({ id, getExpansee }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/expense/${id.id}/`);

      if (res.status === 200) {
        try {
          let imp = await axios.put(`${BASE_URL}/wfm/imprest/${id.imprest}/`, {
            imprest_open: true,
          });
          if (imp.status === 200) {
            await getExpansee();
            setShow(false);
          } else {
            console.log("Imprest Opening Error");
            alert("Error Opening imprest: " + imp.statusText);
          }
        } catch (error) {
          console.error("Error updating imprest:", error);
          alert("Error Opening imprest: " + error.message);
        }
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Expense</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Delete Expense Request
            <div className="button-models">
              <button
                className="model-button  model-button-cancel font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Expenses = ({ emp_code, toggleexpense, expensetogglemanagenet }) => {
  const [imprest, setImprest] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const { PORTAL_SETTINGS, SUPER_ADMIN } = usePermission();
  const getImprest = async () => {
    setBuffering(true); // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/imprestbyemployee/${emp_code ? emp_code : sessionStorage.getItem("emp_code")}/`,
      );
      setImprest(res.data);
    } catch (err) {
      handleAllError(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getImprest();
  }, []);

  const [expansee, setexpansee] = useState([]);

  const getExpansee = async () => {
    setBuffering(true); // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/expensebyemployee/${emp_code ? emp_code : sessionStorage.getItem("emp_code")}/`,
      );
      setexpansee(res.data);
    } catch (err) {
      //toast Logic
      handleAllError(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getExpansee();
  }, []);

  const [toggleState, setToggleState] = useState(toggleexpense || 0);

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + `/expenseSlip`;
  const dynamicUrl = "/" + urlParts[3] + `/dynamicExpenseSlip`;
  let opener = "profile";
  if (expensetogglemanagenet) {
    opener = "request";
  }

  const openExenseSlip = (i) => {
    navigate(baseUrl, { state: { i, opener } });
  };

  const dynamicExenseSlip = (i) => {
    navigate(dynamicUrl, { state: { i, opener } });
  };
  return (
    <div>
      <div className="flex justify-between" style={{ flexWrap: 'wrap', gap: "10px" }}>
        <div className="modern-tab-bar" style={{ margin: '0', marginTop: '8px' }}>
          {[
            { id: 0, label: "Dashboard" },
            { id: 1, label: "Imprest" },
            { id: 2, label: "Expense" }
          ].map(tab => (
            <button
              key={tab.id}
              className={`modern-tab-btn ${toggleState === tab.id ? "active" : ""}`}
              onClick={() => setToggleState(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="right-expense-bloc-tab justify-start" style={{ width:'auto'}}>
          {toggleState === 1 ? (
            <>
              <div>
                {/* <OldImprestAdd getImprest={getImprest} /> */}
                <ImprestAdd getImprest={getImprest} />
              </div>
            </>
          ) : null}
          {toggleState === 2 ? (
            <>
              <div>
                <ExpenseAdd getExpansee={getExpansee} />
              </div>
            </>
          ) : null}
        </div>
      </div>
      <br />

      {toggleState === 0 ? (
        <>
          <EmployeeImprestExpenseDashboard />
        </>
      ) : null}

      {toggleState === 1 ? (
        <>
          {/* Imprest History Details */}
          <div className="table-css-white-background-new scroll-container-table">
            <table className="">
              <thead
                style={{
                  position: "sticky",
                  top: "0",
                  backgroundColor: "#fff",
                  zIndex: "10",
                }}
              >
                <tr className="custom-table-head-tr-new">
                  <th className="table-heading">S. No.</th>
                  {/* <th className="table-heading">Emp Code</th> */}
                  <th className="table-heading">Project </th>
                  <th className="table-heading">Imprest Date</th>
                  <th className="table-heading">Dates</th>
                  <th className="table-heading">Imprest Name</th>
                  <th className="table-heading" style={{ textAlign: "center" }}>
                    Proposed Amount
                  </th>
                  <th className="table-heading" style={{ textAlign: "center" }}>
                    Approved Amount
                  </th>
                  {/* <th className="table-heading">Remaining Amount</th> */}
                  <th className="table-heading">Days And Employee Count</th>
                  {/* <th className="table-heading">No. of Days</th> */}
                  {/* <th className="table-heading">No. of People</th> */}
                  <th className="table-heading" style={{ textAlign: "center" }}>
                    Person Name
                  </th>
                  <th className="table-heading">Remarks</th>
                  <th className="table-heading">Status</th>
                  {/* <th className="table-heading ">Reason</th> */}
                  <th
                    className="table-heading width-5vw"
                    style={{ textAlign: "center" }}
                  >
                    Action
                  </th>

                  {SUPER_ADMIN && (
                    <th className="table-heading width-5vw" style={{ textAlign: "center" }}>
                      Delete
                    </th>
                  )}
                </tr>
              </thead>
              {buffer ? (
                <div className="spinner"></div>
              ) : (
                <tbody>
                  <tr className="tr-border-bottom">
                    <td colSpan={6}></td>
                  </tr>
                  {imprest.map((item, index) => {
                    return (
                      <>
                        <tr className="custom-table-head-td">
                          <td className="table-body">{index + 1}</td>

                          {/* <td className="table-body">
                            {item?.mantra_project_details?.mantra_project_id ?
                              <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td className="table-body" >Project Code</td>
                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right word-wrap-20vw">
                                      {item?.mantra_project_details?.mantra_project_code}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="table-body" >Project Name</td>
                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right word-wrap-20vw">
                                      {item?.mantra_project_details?.mantra_project_name}
                                    </td>
                                  </tr>

                                </tbody>
                              </table> :
                              <div className="align-center justify-center">
                                - No Project Referenced -
                              </div>
                            }
                          </td> */}

                          <td className="table-body">
                            {item.mantra_project_details?.mantra_project_id ? (
                              // Priority 1: Mantra project exists
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right  word-wrap-10vw">
                                      {item.mantra_project_details?.mantra_project_code}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right word-wrap-15vw">
                                      {item.mantra_project_details?.mantra_project_name}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            ) : item.project_id ? (
                              // Priority 2: Fallback to ref project
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right word-wrap-10vw">
                                      {item.ref_project_code}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right word-wrap-15vw">
                                      {item.ref_project_name}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            ) : (
                              // Priority 3: No project at all
                              <div className="justify-center">
                                - No Project Referenced -
                              </div>
                            )}
                          </td>

                          {/* <td className="align-left">{item.empcode}</td> */}
                          <td className="table-body">
                            {formatDate(item.date)}
                          </td>

                          <td className="table-body">
                            <ViewImprestRequestDates i={item} />
                          </td>

                          <td className="table-body word-wrap-15vw">
                            {item.mantra_project_details?.mantra_project_id
                              ? `${item.mantra_project_details?.mantra_project_code}-${item.mantra_project_details?.mantra_project_name}`
                              : `${item.project_name}`}
                            {/* {item?.mantra_project_details?.mantra_project_code}-{item?.mantra_project_details?.mantra_project_name} */}
                          </td>

                          <td className="table-body">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                {[
                                  {
                                    name: "Transportation",
                                    value: item.transportation,
                                  },
                                  {
                                    name: "Accommodation",
                                    value: item.accomodation,
                                  },
                                  { name: "Food", value: item.fooding },
                                ].map(
                                  ({ name, value }) =>
                                    Number(value) !== 0 && (
                                      <tr key={name}>
                                        <td
                                          className="table-body"
                                          style={{ paddingBottom: "5px" }}
                                        >
                                          {name}
                                        </td>
                                        <td style={{ padding: "0px 4px" }}>
                                          :
                                        </td>
                                        <td className="align-right">
                                          {formatCurrencyIndian(value)}
                                        </td>
                                      </tr>
                                    ),
                                )}

                                {item.other_details?.length > 0 &&
                                  item.other_details.map((other, index) => (
                                    <tr
                                      key={other.other_name || `other-${index}`}
                                    >
                                      <td
                                        style={{ paddingBottom: "5px" }}
                                        className="table-body"
                                      >
                                        {other.other_name ||
                                          `Other-${index + 1}`}
                                      </td>
                                      <td style={{ padding: "0px 4px" }}>:</td>
                                      <td className="align-right">
                                        {formatCurrencyIndian(
                                          Number(other.amount) || 0,
                                        )}
                                      </td>
                                    </tr>
                                  ))}

                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <b>Total</b>
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {formatCurrencyIndian(
                                        Number(item.transportation || 0) +
                                        Number(item.accomodation || 0) +
                                        Number(item.fooding || 0) +
                                        (item.other_details?.reduce(
                                          (total, other) =>
                                            total + Number(other.amount || 0),
                                          0,
                                        ) || 0),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>

                          {item.amount_change_reason ? (
                            <td
                              className="table-body"
                              title={`Reason For Change : \n${item.amount_change_reason}`}
                            >
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <tbody>
                                  {[
                                    {
                                      name: "Approved Transportation",
                                      value: item.approved_transportation,
                                      proposed: item.transportation,
                                    },
                                    {
                                      name: "Approved Accommodation",
                                      value: item.approved_accomodation,
                                      proposed: item.accomodation,
                                    },
                                    {
                                      name: "Approved Food",
                                      value: item.approved_fooding,
                                      proposed: item.fooding,
                                    },
                                  ].map(
                                    ({ name, value, proposed }) =>
                                      // Number(value) !== 0 &&
                                      Number(proposed) !== 0 && (
                                        <tr key={name}>
                                          <td
                                            className="table-body"
                                            style={{ paddingBottom: "5px" }}
                                          >
                                            {name}
                                          </td>
                                          <td style={{ padding: "0px 4px" }}>
                                            :
                                          </td>
                                          <td className="align-right">
                                            {formatCurrencyIndian(value)}
                                          </td>
                                        </tr>
                                      ),
                                  )}

                                  {item.other_details?.length > 0 &&
                                    item.other_details.map((other, index) => (
                                      <tr
                                        key={
                                          other.other_name || `other-${index}`
                                        }
                                      >
                                        <td
                                          style={{ paddingBottom: "5px" }}
                                          className="table-body"
                                        >
                                          {other.other_name ||
                                            `Other-${index + 1}`}
                                        </td>
                                        <td style={{ padding: "0px 4px" }}>
                                          :
                                        </td>
                                        <td className="align-right">
                                          {formatCurrencyIndian(
                                            other.approved_other || 0,
                                          )}
                                        </td>
                                      </tr>
                                    ))}

                                  <tr>
                                    <td>
                                      <b>Total</b>
                                    </td>
                                    <td style={{ padding: "0px 4px" }}>:</td>
                                    <td className="text-end">
                                      <b>
                                        {formatCurrencyIndian(
                                          Number(item.approved_transportation) +
                                          Number(item.approved_accomodation) +
                                          Number(item.approved_fooding) +
                                          (item?.other_details?.length > 0
                                            ? item?.other_details?.reduce(
                                              (total, other) =>
                                                total +
                                                Number(
                                                  other.approved_other || 0,
                                                ),
                                              0,
                                            )
                                            : 0),
                                        )}
                                      </b>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          ) : (
                            <td
                              className="table-body"
                              style={{ textAlign: "center" }}
                            >
                              -
                            </td>
                          )}

                          <td className="table-body">
                            For <b>{item.no_of_days}</b> Days with <br />{" "}
                            <b>{item.person}</b>{" "}
                            {item.person > 1 ? "people." : "person."}
                          </td>
                          {/* <td className="align-center">{item.no_of_days}</td> */}
                          {/* <td className="align-center">{item.person}</td> */}
                          <td className="table-body">
                            <ul style={{ paddingLeft: "20px" }}>
                              {item.multiple_person_details.map((items) => {
                                return (
                                  <li>
                                    {items.emp_code} - {items.name}
                                    <br />
                                  </li>
                                );
                              })}
                            </ul>
                          </td>
                          <td className="table-body word-wrap-10vw">
                            {item.remarks}
                          </td>

                          <td title="Status And Remarks" className="table-body">
                            <ViewImprestRequestStatus i={item} />
                          </td>

                          <td className="table-body">
                            <span
                              request-status={
                                item.rh_leave_status === "rejected" ||
                                  item.admin_leave_status === "rejected" ||
                                  item.account_leave_status === "rejected"
                                  ? "rejected"
                                  : item.account_leave_status === "pending"
                                    ? "pending"
                                    : item.account_leave_status
                              }
                              className="request-status table-body"
                            >
                              {" "}
                              {(item.rh_leave_status === "pending" &&
                                item.admin_leave_status === "pending" &&
                                item.account_leave_status === "pending") ||
                                item.rh_leave_status === "rejected" ? (
                                <div className="table-heading">
                                  <ImprestModelDelete
                                    getImprest={getImprest}
                                    id={item}
                                  />
                                </div>
                              ) : // item.rh_leave_status === "rejected" || item.admin_leave_status === "rejected" ||
                                item.account_leave_status !== "pending" ? (
                                  <span
                                    style={{ cursor: "help" }}
                                    title={`Transaction/Cheque No.:\n${item.account_leave_status !== "pending" ? item.account_approved_final_details : null}`}
                                  >
                                    {item.account_leave_status === "approved"
                                      ? "Process Completed"
                                      : item.rh_leave_status === "rejected"
                                        ? "Process Terminated"
                                        : ""}

                                    <br />
                                    {item.account_transaction_proof ? (
                                      <a
                                        className="modal-button-black"
                                        href={item.account_transaction_proof}
                                        target="blank"
                                      >
                                        View
                                      </a>
                                    ) : (
                                      "No Proof Attached"
                                    )}
                                  </span>
                                ) : (
                                  <div className="table-heading">In Process</div>
                                )}
                            </span>
                            {/* {item?.expense_details?.expense_id ? */}
                            {!(
                              item?.expense_details?.expense_id &&
                              item?.expense_details?.submit_for_approval
                            ) && item.account_leave_status === "approved" ? (
                              (() => {
                                const imprestApprovalDate = new Date(
                                  item.account_update_datetime ||
                                  item.apply_datetime ||
                                  item.date,
                                );
                                const today = new Date();
                                const timeDiff = today - imprestApprovalDate;
                                const daysPassed = Math.floor(
                                  timeDiff / (1000 * 60 * 60 * 24),
                                );

                                let submissionNote = "";
                                let noteClass = "";

                                if (PORTAL_SETTINGS?.expense_submit_limit) {
                                  const limit =
                                    PORTAL_SETTINGS.expense_submit_limit_days;

                                  if (daysPassed < limit) {
                                    const daysRemaining = limit - daysPassed;
                                    submissionNote = `${daysRemaining} day${daysRemaining > 1 ? "s" : ""} left for submission`;
                                    noteClass = "approved";
                                  } else if (daysPassed === limit) {
                                    submissionNote = `Last day to submit`;
                                    noteClass = "pending";
                                  } else {
                                    const daysLate = daysPassed - limit;
                                    submissionNote = `${daysLate} day${daysLate > 1 ? "s" : ""} late for submission`;
                                    noteClass = "rejected";
                                  }
                                }

                                return (
                                  <div
                                    className="request-status"
                                    request-status={noteClass}
                                  >
                                    {submissionNote}
                                  </div>
                                );
                              })()
                            ) : (
                              <div className="request-status"></div>
                            )}
                          </td>

                          {SUPER_ADMIN && (
                            <td className="table-body align-center">
                              <div className="table-heading">
                                  <ImprestModelDelete
                                    getImprest={getImprest}
                                    id={item}
                                  />
                                </div>
                            </td>
                          )}
                        </tr>
                        <tr className="tr-border-bottom">
                          <td colSpan={6}></td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              )}
            </table>
          </div>
        </>
      ) : null}

      {toggleState === 2 ? (
        <>
          {/* Expense History Details */}
          <div className="table-css-white-background-new scroll-container-table">
            <table className="">
              <thead
                style={{
                  position: "sticky",
                  top: "0",
                  backgroundColor: "#fff",
                  zIndex: "10",
                }}
              >
                <tr className="custom-table-head-tr-new">
                  <th className="table-heading">S. No.</th>
                  <th className="table-heading">Project </th>
                  <th className="table-heading">Date</th>
                  {/* <th className="table-heading">Site Name</th> */}
                  {/* <th className="table-heading">Expense Name</th> */}
                  <th className="table-heading">
                    Expense <b>Against</b> Imprest
                  </th>
                  <th className="table-heading">Approved Imprest Amount</th>
                  <th className="table-heading">Expense Amount</th>
                  <th className="table-heading">Bills</th>
                  <th className="table-heading">View Slip</th>
                  <th className="table-heading">Status</th>
                  <th className="table-heading width-15vw">Remarks</th>
                  <th className="table-heading width-5vw">Action</th>
                </tr>
              </thead>
              {buffer ? (
                <div className="spinner"></div>
              ) : (
                <tbody>
                  <tr className="tr-border-bottom">
                    <td colSpan={7}></td>
                  </tr>
                  {expansee
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((item, index) => {
                      return (
                        <>
                          <tr className="custom-table-head-td">
                            <td className="table-body">{index + 1}</td>
                            <td className="table-body">
                              {/* {item?.imprest_data?.mantra_project_details?.mantra_project_id ?
                                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                  <tbody>
                                    <tr>
                                      <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                      <td style={{ padding: "0px 4px" }}>:</td>
                                      <td className="align-right word-wrap-10vw">
                                        {item?.imprest_data?.mantra_project_details?.mantra_project_code}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                      <td style={{ padding: "0px 4px" }}>:</td>
                                      <td className="align-right word-wrap-10vw">
                                        {item?.imprest_data?.mantra_project_details?.mantra_project_name}
                                      </td>
                                    </tr>

                                  </tbody>
                                </table> :
                                <div className="justify-center">
                                  - No Project Referenced -
                                </div>
                              } */}
                              <td className="table-body">
                                {item?.imprest_data?.mantra_project_details
                                  ?.mantra_project_id ? (
                                  // Priority 1: Mantra project exists
                                  <table
                                    style={{
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                        <td className="align-right word-wrap-10vw">
                                          {item?.imprest_data?.mantra_project_details?.mantra_project_code}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                        <td className="align-right word-wrap-15vw">
                                          {item?.imprest_data?.mantra_project_details?.mantra_project_name}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                ) : item.imprest_data?.project_id ? (
                                  // Priority 2: Fallback to ref project
                                  <table
                                    style={{
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                        <td className="align-right word-wrap-10vw">
                                          {item.imprest_data?.ref_project_code}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                        <td className="align-right word-wrap-15vw">
                                          {item.imprest_data?.ref_project_name}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                ) : (
                                  // Priority 3: No project at all
                                  <div className="justify-center">
                                    - No Project Referenced -
                                  </div>
                                )}
                              </td>
                            </td>
                            <td className="table-body">
                              {formatDate(item.date)}
                            </td>
                            <td className="table-body word-wrap-10vw">
                              <span>{item.name}</span>
                              <br />
                              <b> Against </b>
                              <br />
                              <span>
                                {item?.imprest_data?.mantra_project_details
                                  ?.mantra_project_id
                                  ? `${item?.imprest_data?.mantra_project_details?.mantra_project_code}-${item?.imprest_data?.mantra_project_details?.mantra_project_name}`
                                  : `${item.project_name}`}
                                {/* {item?.imprest_data?.mantra_project_details?.mantra_project_code}-{item?.imprest_data?.mantra_project_details?.mantra_project_name} */}
                              </span>
                            </td>
                            {/* <td className="table-body">{item.project_name}</td> */}
                            {/* <td className="table-body">{item.name}</td> */}
                            <td
                              className="table-body"
                              title={`Reason For Change : \n${item.amount_change_reason}`}
                            >
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <tbody>
                                  {[
                                    {
                                      name: "Approved Transportation",
                                      value: item.approved_transportation,
                                      proposed: item.transportation,
                                    },
                                    {
                                      name: "Approved Accommodation",
                                      value: item.approved_accomodation,
                                      proposed: item.accomodation,
                                    },
                                    {
                                      name: "Approved Food",
                                      value: item.approved_fooding,
                                      proposed: item.fooding,
                                    },
                                  ].map(
                                    ({ name, value, proposed }) =>
                                      // Number(value) !== 0 &&
                                      Number(proposed) !== 0 && (
                                        <tr key={name}>
                                          <td
                                            className="table-body"
                                            style={{ paddingBottom: "5px" }}
                                          >
                                            {name}
                                          </td>
                                          <td style={{ padding: "0px 4px" }}>
                                            :
                                          </td>
                                          <td className="align-right">
                                            {formatCurrencyIndian(value)}
                                          </td>
                                        </tr>
                                      ),
                                  )}

                                  {item.other_details?.length > 0 &&
                                    item.other_details.map((other, index) => (
                                      <tr
                                        key={
                                          other.other_name || `other-${index}`
                                        }
                                      >
                                        <td
                                          style={{ paddingBottom: "5px" }}
                                          className="table-body"
                                        >
                                          {other.other_name ||
                                            `Other-${index + 1}`}
                                        </td>
                                        <td style={{ padding: "0px 4px" }}>
                                          :
                                        </td>
                                        <td className="align-right">
                                          {formatCurrencyIndian(
                                            other.approved_other || 0,
                                          )}
                                        </td>
                                      </tr>
                                    ))}

                                  <tr>
                                    <td>
                                      <b>Total</b>
                                    </td>
                                    <td style={{ padding: "0px 4px" }}>:</td>
                                    <td className="text-end">
                                      <b>
                                        {formatCurrencyIndian(
                                          Number(item.approved_transportation) +
                                          Number(item.approved_accomodation) +
                                          Number(item.approved_fooding) +
                                          (item?.other_details?.length > 0
                                            ? item?.other_details?.reduce(
                                              (total, other) =>
                                                total +
                                                Number(
                                                  other.approved_other || 0,
                                                ),
                                              0,
                                            )
                                            : 0),
                                        )}
                                      </b>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            {item.submit_for_approval === false ? (
                              <td className="table-body align-center">
                                <span
                                  request-status={"pending"}
                                  className="request-status"
                                >
                                  Expense Not Submitted
                                </span>
                              </td>
                            ) : (
                              <td className="table-body">
                                <table
                                  style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="table-body"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Utilized Bills
                                      </td>
                                      <td style={{ padding: "0px 4px" }}>:</td>
                                      <td className="align-right">
                                        {item.utilized_amount
                                          ? formatRoundoff2D(
                                            item.utilized_amount,
                                          )
                                          : "-"}{" "}
                                        Rs
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        className="table-body"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Remaining Balance
                                      </td>
                                      <td style={{ padding: "0px 4px" }}>:</td>
                                      <td className="align-right">
                                        {item.remaining_amount
                                          ? formatRoundoff2D(
                                            item.remaining_amount,
                                          )
                                          : "-"}{" "}
                                        Rs
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            )}

                            <td className="table-body align-center">
                              {item.imprest_account_leave_status ===
                                "pending" ? (
                                <spam
                                  request-status={item.account_status_b}
                                  className="request-status align-center"
                                >
                                  Imprest Approval Pending ⌛
                                </spam>
                              ) : (
                                <ExpenseDetailsAdd
                                  i={item}
                                  expansee={getExpansee}
                                  totall={
                                    Number(item.approved_transportation) +
                                    Number(item.approved_accomodation) +
                                    Number(item.approved_fooding) +
                                    (item.other_details?.length > 0
                                      ? item.other_details.reduce(
                                        (total, other) =>
                                          total +
                                          Number(other.approved_other || 0),
                                        0,
                                      )
                                      : 0)
                                  }
                                  utilize={item.utilized_amount}
                                  remain={item.remaining_amount}
                                />
                              )}
                            </td>

                            <td className="table-body  align-center">
                              <button
                                className="allproject-dashboard"
                                title="View using Navigate"
                                onClick={(e) => openExenseSlip(item)}
                              // onClick={(e) => dynamicExenseSlip(item)}
                              >
                                <Eye />
                              </button>
                            </td>

                            {item.submit_for_approval === false ? (
                              <td className="table-body align-center">
                                <span
                                  request-status={"pending"}
                                  className="request-status"
                                >
                                  Expense Not Submitted
                                </span>
                              </td>
                            ) : (
                              <td className="table-body">
                                <span
                                  request-status={item.rh_status}
                                  className="request-status "
                                  title={
                                    item.rh_status === "rejected"
                                      ? `Rh Reject Reason : ${item.rh_rejection_reason}`
                                      : ""
                                  }
                                >
                                  {item.rh_status === "pending"
                                    ? "Pending For Rh Approval ⌛"
                                    : item.rh_status === "rejected"
                                      ? "Rh ✖, "
                                      : "Rh ✔, "}
                                </span>
                                <br />
                                <span
                                  request-status={item.account_status_a}
                                  className="request-status "
                                  title={
                                    item.account_status_a === "rejected"
                                      ? `Account Reject Reason : ${item.account1_rejection_reason}`
                                      : ""
                                  }
                                >
                                  {item.rh_status === "rejected" &&
                                    item.admin_status === "rejected" &&
                                    item.account_status_a === "rejected"
                                    ? "Account Stage 1 ✖, "
                                    : item.rh_status === "approved" &&
                                      item.admin_status === "approved" &&
                                      item.account_status_a === "pending"
                                      ? "Pending For Account Approval ⌛"
                                      : item.rh_status === "approved" &&
                                        item.admin_status === "approved" &&
                                        item.account_status_a === "rejected"
                                        ? "Accounts Stage 1 ✖, "
                                        : item.rh_status === "approved" &&
                                          item.admin_status === "approved" &&
                                          item.account_status_a === "approved"
                                          ? "Accounts Stage 1 ✔, "
                                          : "Accounts Stage 1: " +
                                          item.account_status_a}
                                </span>
                                <br />
                                <span
                                  request-status={item.admin_status}
                                  className="request-status "
                                  title={
                                    item.admin_status === "rejected"
                                      ? `Admin Reject Reason : ${item.admin_rejection_reason}`
                                      : ""
                                  }
                                >
                                  {item.rh_status === "rejected" &&
                                    item.admin_status === "rejected"
                                    ? "Admin ✖, "
                                    : item.rh_status === "approved" &&
                                      item.admin_status === "pending"
                                      ? "Pending For Admin Approval ⌛,"
                                      : item.rh_status === "approved" &&
                                        item.admin_status === "rejected"
                                        ? "Admin ✖, "
                                        : item.rh_status === "approved" &&
                                          item.admin_status === "approved"
                                          ? "Admin ✔, "
                                          : "Admin Status: " +
                                          item.admin_status}
                                </span>
                                <br />
                                <span
                                  request-status={item.account_status_b}
                                  className="request-status "
                                >
                                  {item.rh_status === "rejected" &&
                                    item.admin_status === "rejected" &&
                                    item.account_status_b === "rejected"
                                    ? "Account Stage 2 ✖, "
                                    : item.rh_status === "approved" &&
                                      item.admin_status === "approved" &&
                                      item.account_status_b === "pending"
                                      ? "Pending For Account Finalization ⌛"
                                      : item.rh_status === "approved" &&
                                        item.admin_status === "approved" &&
                                        item.account_status_b === "rejected"
                                        ? "Accounts Stage 2 ✖, "
                                        : item.rh_status === "approved" &&
                                          item.admin_status === "approved" &&
                                          item.account_status_b === "approved"
                                          ? "Accounts Stage 2 ✔, "
                                          : "Accounts Stage 2: " +
                                          item.account_status_b}
                                </span>
                              </td>
                            )}

                            <td
                              title="Remarks and Approval Dates"
                              className="table-body"
                            >
                              <span
                                request-status={item.rh_status}
                                className="request-status "
                              >
                                {item.rh_status === "pending"
                                  ? "-"
                                  : item.rh_status === "rejected"
                                    ? `Rh Reject Reason : ${item.rh_rejection_reason}`
                                    : `Rh${item.rh_assigned ? `(${item.rh_assigned}-${item.rh_assigned_name}) ` : ""}: Verified Amounts for Bills ${item.rh_update_datetime ? `At: ${formatDateTime(item.rh_update_datetime).date}` : ""}`}
                              </span>
                              <br />
                              <span
                                request-status={item.account_status_a}
                                className="request-status "
                              >
                                {item.account_status_a === "pending"
                                  ? "-"
                                  : item.account_status_a === "rejected"
                                    ? `Accounts Reject Reason : ${item.account1_rejection_reason}`
                                    : `Accounts${item.account_update_by ? `(${item.account_update_by}-${item.account_update_by_name}) ` : ""}: Bills Verified ${item.account_update_datetime ? `At: ${formatDateTime(item.account_update_datetime).date}` : ""}`}
                              </span>
                              <br />
                              <span
                                request-status={item.admin_status}
                                className="request-status "
                                title={
                                  item.admin_status === "rejected"
                                    ? `Admin Reject Reason : ${item.admin_rejection_reason}`
                                    : ""
                                }
                              >
                                {item.admin_status === "pending"
                                  ? "-"
                                  : item.admin_status === "rejected"
                                    ? `Admin Rejection Reason : ${item.admin_rejection_reason}`
                                    : `Admin${item.admin_update_by ? `(${item.admin_update_by}-${item.admin_update_by_name}) ` : ""}: Approved After Final Verification  ${item.admin_update_datetime ? `At: ${formatDateTime(item.admin_update_datetime).date}` : ""}`}
                              </span>
                              <br />
                              <span
                                request-status={item.account_status_b}
                                className="request-status "
                              >
                                {item.account_status_b === "pending"
                                  ? "-"
                                  : item.account_status_b === "rejected"
                                    ? `Final Rejection Reason : ${item.account2_rejection_reason}`
                                    : `Final${item.final_update_by ? `(${item.final_update_by}-${item.final_update_by_name}) ` : ""}: Approved And Settled ${item.final_update_datetime ? `At: ${formatDateTime(item.final_update_datetime).date}` : ""}`}
                              </span>
                            </td>

                            <td
                              className="table-body align-center"
                              key={item.action}
                            >
                              <span>
                                {" "}
                                {item.submit_for_approval === false ? (
                                  <span
                                    request-status={
                                      item.imprest_account_leave_status
                                    }
                                    className="request-status flex-row"
                                    title={`${item.imprest_account_leave_status === "rejected" ? `Reason: ${item.account_rejection_reason}` : ""}`}
                                  >
                                    {" "}
                                    {item.imprest_account_leave_status ===
                                      "rejected" ? (
                                      "Imprest Account ✖, "
                                    ) : item.imprest_account_leave_status ===
                                      "pending" ? (
                                      "Imprest Approval Pending ⌛"
                                    ) : item.imprest_account_leave_status ===
                                      "rejected" ? (
                                      "Imprest Accounts ✖, "
                                    ) : item.imprest_account_leave_status ===
                                      "approved" ? (
                                      <ExpenseSubmit
                                        getExpansee={getExpansee}
                                        i={item}
                                        total={
                                          Number(item.approved_transportation) +
                                          Number(item.approved_accomodation) +
                                          Number(item.approved_fooding) +
                                          (item.other_details?.length > 0
                                            ? item.other_details.reduce(
                                              (total, other) =>
                                                total +
                                                Number(
                                                  other.approved_other || 0,
                                                ),
                                              0,
                                            )
                                            : 0)
                                        }
                                      />
                                    ) : (
                                      "Accounts Status: " +
                                      item.imprest_account_leave_status
                                    )}
                                    <br />
                                    <ExpenseModelDelete
                                      getExpansee={getExpansee}
                                      id={item}
                                    />
                                  </span>
                                ) : item.partially_change ? (
                                  <span
                                    request-status={"rejected"}
                                    className="request-status "
                                  >
                                    Update Bills
                                    <br />
                                    <ExpensePartialSubmit
                                      getExpansee={getExpansee}
                                      i={item}
                                      total={
                                        Number(item.approved_transportation) +
                                        Number(item.approved_accomodation) +
                                        Number(item.approved_fooding) +
                                        (item.other_details?.length > 0
                                          ? item.other_details.reduce(
                                            (total, other) =>
                                              total +
                                              Number(
                                                other.approved_other || 0,
                                              ),
                                            0,
                                          )
                                          : 0)
                                      }
                                    />
                                  </span>
                                ) : item.account_status_b === "pending" ? (
                                  <span
                                    request-status={"pending"}
                                    className="request-status "
                                  >
                                    {" "}
                                    In Process...
                                  </span>
                                ) : (
                                  <span
                                    request-status={"approved"}
                                    className="request-status "
                                  >
                                    Process Completed.
                                  </span>
                                )}
                              </span>
                            </td>
                          </tr>
                          {/* <tr className="tr-border-bottom">
                            <td colSpan={7}></td>
                          </tr> */}
                        </>
                      );
                    })}
                </tbody>
              )}
            </table>
          </div>
        </>
      ) : null
      }
    </div >
  );
};

export default Expenses;
